export default __webpack_public_path__ + "static/media/162.078a64e8.png";